module.exports = __webpack_public_path__ + "img/info_30_button.568864ff.png";